// Override Settings
var bcSfFilterSettings = {
    general: {
        limit: bcSfFilterConfig.custom.products_per_page,
        /* Optional */
        loadProductFirst: false,
    }
};

// Declare Templates
var bcSfFilterTemplate = {
    // Card Template
    'productCardItemHtml': '<div id="gridparent" class="grid__item ' + bcSfFilterConfig.custom.collection_products_per_row + ' quarter-width medium--one-half small--one-half ee product-second-square-{{index}}">' +
                               '<div id="dummy"></div>' +
                                '<div id="element" class="collection-product {{itemSoldOutClass}}">' +
                                   
                                    '<div class="{{itemCycleClass}} card-shadow">' +
                                     '{{itemLabels}}' +
                                        '<a href="{{itemUrl}}" class="grid__image {{itemSoldOutImageClass}}">' +
                                            '<img src="{{itemThumbUrl}}" alt="{{itemTitle}}">' +
                                        '</a>' +
                                        '<div class="product-overlay">' +
                                            '<a href="{{itemUrl}}" class="product-grid-card-wrapper"> </a>' +
                                            '<a href="{{itemUrl}}" class="product-grid-card-link">' +
                                                '<p class="h2 product-title">{{itemMinTitle}}</p>' +
                                                '{{itemPrice}}' +
                                            '</a>' +
                                        '</div>' +
                                    '</div>' + 
                                    '<div class="large--hide medium-down--show card-shadow mobile-square-title {{itemCycleMobileClass}}">' +
                                        '<a href="{{itemTitle}}" class="product-grid-card-link">' +
                                            '<div class="mobile-price-container">' +
                                                '<p class="h2 product-title">' +
                                                    '<a href="{{itemUrl}}">{{itemMinTitle2}}</a>' +
                                                '</p>' +
                                                '{{itemPriceMobile}}' +
                                            '</div>' +
                                        '</a>' +
                                    '</div>' +
                                '</div>' +
                            '</div>' +
                            '{{itemAdditional}}',
  
    // Grid Template
    'productGridItemHtml': '<div class="grid__item ' + bcSfFilterConfig.custom.grid_item_width + ' text-center grid-product-container {{itemBadgeLayoutClass}}">' +
                                '<div class="ptest">' +
                                    //'<div id="relproduct-dummy"></div>' +
                                    '<a href="{{itemUrl}}">' +
                                        '<div {{itemSoldOutClass}}>' +
                                            '{{itemImage}}' +
                                            '{{itemLabels}}' +
                                            '{{itemBdnBadge}}' +
                                        '</div>' +
                                    '</a>' +
                                '</div>' +
  								'<p class="collection-title-height">' +
  									'<a href="{{itemUrl}}">{{itemTruncateTitle}}</a>' +
  								'</p>' +
  								'<div class="product-price-grid">' + 
  									'{{itemPrice}}' +
  									'{{itemWishList}}' +
  									'{{itemQuickView}}' +
  								'</div>' +
                            '</div>',

    // Pagination Template
    'previousActiveHtml': '<span class="prev"><a href="{{itemUrl}}" title="">←</a></span>',
    'previousDisabledHtml': '',
    'nextActiveHtml': '<span class="next"><a href="{{itemUrl}}" title="">→</a></span>',
    'nextDisabledHtml': '',
    'pageItemHtml': '<span class="page"><a href="{{itemUrl}}" title="">{{itemTitle}}</a></span>',
    'pageItemSelectedHtml': '<span class="page current">{{itemTitle}}</span>',
    'pageItemRemainHtml': '<span class="deco">{{itemTitle}}</span>',
    'paginateHtml': '{{previous}}{{pageItems}}{{next}}',
  
    // Sorting Template
    'sortingHtml': '<label>' + bcSfFilterConfig.label.sorting + '</label><select>{{sortingItems}}</select>',
};

/************************** BUILD PRODUCT LIST **************************/

// Build Product Grid Item
BCSfFilter.prototype.buildProductGridItem = function(data, index) {
    /*** Prepare data ***/
    var images = data.images_info;
     // Displaying price base on the policy of Shopify, have to multiple by 100
    var soldOut = !data.available; // Check a product is out of stock

    var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    var priceVaries = data.price_min != data.price_max; // Check a product has many prices
    // Get First Variant (selected_or_first_available_variant)
    var firstVariant = data['variants'][0];
    if (getParam('variant') !== null && getParam('variant') != '') {
        var paramVariant = data.variants.filter(function(e) { return e.id == getParam('variant'); });
        if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
    } else {
        for (var i = 0; i < data['variants'].length; i++) {
            if (data['variants'][i].available) {
                firstVariant = data['variants'][i];
                break;
            }
        }
    }
    /*** End Prepare data ***/

    // Get Template
    if (bcSfFilterConfig.custom.collection_style == 'card') {
        var itemHtml = bcSfFilterTemplate.productCardItemHtml;
    } else {
        var itemHtml = bcSfFilterTemplate.productGridItemHtml;
    }

    // Add custom class
    var itemSoldOutClass = soldOut ? 'collection-product-sold-out' : '';
    var itemSoldOutImageClass = soldOut ? 'collection-product-unavailable' : '';
    var itemCycleClass = (index == 1 || index % 2 == 1) ? 'collection-box-1' : 'collection-box-2';
    var itemCycleMobileClass = (index == 1 || index % 2 == 1) ? 'mobile-collection-margin-1' : 'mobile-collection-margin-2';
    itemHtml = itemHtml.replace(/{{itemSoldOutClass}}/g, itemSoldOutClass);
    itemHtml = itemHtml.replace(/{{itemSoldOutImageClass}}/g, itemSoldOutImageClass);
    itemHtml = itemHtml.replace(/{{itemCycleClass}}/g, itemCycleClass);
    itemHtml = itemHtml.replace(/{{itemCycleMobileClass}}/g, itemCycleMobileClass);

    // Add Thumbnail
  	var itemImageHtml = '';
  	if (images.length > 0) {
        var aspect_ratio = images[0]['width'] / images[0]['height'];
        var img_url = this.optimizeImage(images[0]['src'], '1x1').replace('_1x1.', '_{width}x.');
        itemImageHtml += '<img class="itest lazyload "' +
          					' src="' + this.optimizeImage(images[0]['src'], '300x') + '"' +
          					' data-parent-fit="cover"' +
          					' data-src="' + img_url + '"' +
          					' data-widths="[360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]"' +
          					' data-aspectratio="' + aspect_ratio + '"' +
          					' data-sizes="auto" alt="{{itemTitle}}">';
    } else {
        itemImageHtml += bcSfFilterConfig.general.no_image_url;
    }
    itemHtml = itemHtml.replace(/{{itemImage}}/g, itemImageHtml);
  
  	// Add item Tittle (truncate word 10)
    itemHtml = itemHtml.replace(/{{itemTruncateTitle}}/g, this.truncateByWord(data.title, 10, ''));

    // Add Price
    var itemPriceHtml = '';
    if (bcSfFilterConfig.custom.collection_style == 'card') {
        if (priceVaries) {
            itemPriceHtml += '<p class="h2 product-price">' + bcSfFilterConfig.label.from_price.replace(/{{ price }}/g, this.formatMoney(data.price_min)) + '</p>';
        } else {
            itemPriceHtml += '<p class="h2 product-price">' + this.formatMoney(data.price_min) + '</p>';
        }
    } else {
        if (onSale) {
            if (priceVaries) {
                itemPriceHtml += '<p class="product-price">' + bcSfFilterConfig.label.sale_from_price.replace(/{{ price }}/g, this.formatMoney(data.price_min)) + '</p>';
            } else {
                itemPriceHtml += '<p class="product-price">' + this.formatMoney(data.price_min) + ' <span class="grid_compare_price">' + this.formatMoney(data.compare_at_price_min) + '</span></p>';
            }
        } else {
            if (priceVaries) {
                itemPriceHtml += '<p class="product-price">' + bcSfFilterConfig.label.from_price.replace(/{{ price }}/g, this.formatMoney(data.price_min)) + '</p>';
            } else {
                itemPriceHtml += '<p class="product-price">' + this.formatMoney(data.price_min) + '</p>';
            }
        }
    }
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

    // Add Price Mobile
    var itemPriceMobileHtml = '';
    if (onSale) {
        if (priceVaries) {
            itemPriceMobileHtml += '<p class="h3 product-price product-on-sale">' + bcSfFilterConfig.label.sale_from_price.replace(/{{ price }}/g, this.formatMoney(data.price_min) )+ '</p>';
        } else {
            itemPriceMobileHtml += '<p class="h3 product-price">' + this.formatMoney(data.price_min) + '</p>';
        }
    } else {
        if (priceVaries) {
            itemPriceMobileHtml += '<p class="h3 product-price">';
            if (soldOut) {
                itemPriceMobileHtml += '<s>' + bcSfFilterConfig.label.from_price.replace(/{{ price }}/g, this.formatMoney(data.price_min)) + '</s>';
            } else {
                itemPriceMobileHtml += bcSfFilterConfig.label.from_price.replace(/{{ price }}/g, this.formatMoney(data.price_min));
            }
        } else {
            itemPriceMobileHtml += '<p class="h3 product-price">';
            if (soldOut) {
                itemPriceMobileHtml += '<s>' + this.formatMoney(data.price_min) + '</s>';
            } else {
                itemPriceMobileHtml += this.formatMoney(data.price_min);
            }
        }
        itemPriceMobileHtml += '</p>';
    }
    itemHtml = itemHtml.replace(/{{itemPriceMobile}}/g, itemPriceMobileHtml);

    var badgeProductText = [
    data.title || '',
    data.product_type || '',
    data.vendor || '',
    Array.isArray(data.tags) ? data.tags.join(' ') : ''
].join(' ').toLowerCase();

var itemBadgeLayoutClass = /salt|base|liquid|100ml|50ml|נוזל|נוזלי|black note|riot squad/.test(badgeProductText) ? ' vp-liquid-badge-layout' : '';

    // Add Labels
    var itemLabelsHtml = '';
    if (soldOut) {
        itemLabelsHtml += '<div class="sold-out' + itemBadgeLayoutClass + '">';
        itemLabelsHtml += '<span class="icon icon-soldout" aria-hidden="true"></span>';
        itemLabelsHtml += '<span class="fallback-text"></span>';
        itemLabelsHtml += '<div class="Sold Out Badge collection-product-soldout-badge"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 60"><g><title>Layer 1</title><ellipse stroke="#000" ry="30" rx="30" cy="30" cx="30" stroke-width="0" fill="#9d9fa2"></ellipse>' +
'<text font-weight="bold" stroke="#000" xml:space="preserve" text-anchor="middle" font-family="Helvetica, Arial, sans-serif" font-size="10px" y="33" x="29" stroke-opacity="null" stroke-width="0" fill="#ffffff">SOLD-OUT</text>' + '</g></svg></div>';
        itemLabelsHtml += '</div>';
    } else {
        if (onSale) {
            itemLabelsHtml += '<div>';
            itemLabelsHtml += '<span class="icon icon-sale" aria-hidden="true"></span>';
            itemLabelsHtml += '<span class="fallback-text"></span>';
            itemLabelsHtml += '<div class="sale-badge collection-product-sale-badge"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 60"><g><ellipse ry="30" rx="30"  cy="30" cx="30" stroke-width="0" stroke="black" fill="' + bcSfFilterConfig.custom.sale_badge_color + '"></ellipse><text font-weight="bold" stroke="#000" xml:space="preserve" text-anchor="middle" font-family="Helvetica, Arial, sans-serif" font-size="12px"  y="33" x="29" stroke-opacity="null" stroke-width="0" fill="#ffffff">SALE</text></g></svg></div>';
            itemLabelsHtml += '</div>';
        }
    }
    itemHtml = itemHtml.replace(/{{itemLabels}}/g, itemLabelsHtml);

  
  	// Add SmartWishList
  	var itemSmartWishList = '<span class="smartwishlist" data-product="{{itemId}}" data-variant="' + firstVariant.id + '"></span>';
    itemHtml = itemHtml.replace(/{{itemWishList}}/g, itemSmartWishList);
  
  	// Add QuickView
  	var itemQuickViewHtml = '';
    if (bcSfFilterConfig.custom.enable_quick) {
      itemQuickViewHtml += '<a data-fancybox data-type="ajax" data-src="{{itemUrl}}" data-filter="#quick" href="javascript:;" class="quick-view">';
      itemQuickViewHtml += bcSfFilterConfig.label.quick_view;
      itemQuickViewHtml += '<div class="quick-star" style="display:none;">';
      itemQuickViewHtml += '<span class="shopify-product-reviews-badge" data-id="{{itemId}}"></span>';
      itemQuickViewHtml += '</div>';
      itemQuickViewHtml += '</a>';
    }
  	itemHtml = itemHtml.replace(/{{itemQuickView}}/g, itemQuickViewHtml);

    // Additional item
    var itemAdditionalHtml = '';
    if (index == 2 && bcSfFilterConfig.custom.collection_ad_text_richtext != '') {
        itemAdditionalHtml +=   '<div id="gridparentad" class="grid__item ' + bcSfFilterConfig.custom.collection_products_per_row + '  collection-ad-mobile margin-B-M ' + bcSfFilterConfig.custom.collection_column_width + ' quarter-width product-square-grid-ad medium--one-half ff small--one-whole product-grid-square">' +
                                    '<div id="dummy"></div>' +
                                    '<div class="collection-page-ad card-shadow collection-product collection-box-1" id="element">' +
                                        '<div class="collection-ad-text rte">' +
                                            '<h1>' + this.truncateByChar(bcSfFilterConfig.custom.collection_ad_text_richtext, 140) + '</h1>' +
                                        '</div>' +
                                    '</div>' +
                                '</div>';
    }
    itemHtml = itemHtml.replace(/{{itemAdditional}}/g, itemAdditionalHtml);

    // Add main attribute (Always put at the end of this function)
    itemHtml = itemHtml.replace(/{{index}}/g, index);
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));

    // VP- Added code for a new discount badge
var itemBdnBadge = '';
var bdnLang = 'he';

if (window.Shopify && Shopify.locale) {
  bdnLang = Shopify.locale.toLowerCase().split('-')[0];
}

if (document.documentElement.lang) {
  bdnLang = document.documentElement.lang.toLowerCase().split('-')[0];
}

var bdnUrlLang = window.location.pathname.split('/')[1];

if (/^(he|en|ru|ar)$/i.test(bdnUrlLang)) {
  bdnLang = bdnUrlLang.toLowerCase();
}

var bdnBadgeText = {
  he: '\u05d4\u05e0\u05d7\u05ea \u05db\u05de\u05d5\u05ea',
  iw: '\u05d4\u05e0\u05d7\u05ea \u05db\u05de\u05d5\u05ea',
  en: 'Qty deal',
  ru: '\u0421\u043a\u0438\u0434\u043a\u0430 \u0437\u0430 \u043a\u043e\u043b-\u0432\u043e',
  ar: '\u062e\u0635\u0645 \u0643\u0645\u064a\u0629'
}[bdnLang] || '\u05d4\u05e0\u05d7\u05ea \u05db\u05de\u05d5\u05ea';

var bdnBadgeDir = (bdnLang === 'he' || bdnLang === 'iw' || bdnLang === 'ar') ? 'rtl' : 'ltr';

if (data.tags && data.tags.indexOf('bulk_discount') !== -1) {
  itemBdnBadge = '<span class="badge badge--bdn" dir="' + bdnBadgeDir + '">' + bdnBadgeText + '</span>';
}

itemHtml = itemHtml.replace(/{{itemBdnBadge}}/g, itemBdnBadge);

var itemBadgeLayoutClass = window.location.pathname.indexOf('/collections/salt-base') !== -1 ? 'vp-liquid-badge-layout' : '';
itemHtml = itemHtml.replace(/{{itemBadgeLayoutClass}}/g, itemBadgeLayoutClass);

    return itemHtml;
};

/************************** END BUILD PRODUCT LIST **************************/

// Build Pagination
BCSfFilter.prototype.buildPagination = function(totalProduct) {
    if (this.getSettingValue('general.paginationType') == 'default') {
        // Get page info
        var currentPage = parseInt(this.queryParams.page);
        var totalPage = Math.ceil(totalProduct / this.queryParams.limit);

        // If it has only one page, clear Pagination
        if (totalPage == 1) {
            jQ(this.selector.pagination).html('');
            return false;
        }

        if (this.getSettingValue('general.paginationType') == 'default') {
            var paginationHtml = bcSfFilterTemplate.paginateHtml;

            // Build Previous
            var previousHtml = (currentPage > 1) ? bcSfFilterTemplate.previousActiveHtml : bcSfFilterTemplate.previousDisabledHtml;
            previousHtml = previousHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage - 1));
            paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

            // Build Next
            var nextHtml = (currentPage < totalPage) ? bcSfFilterTemplate.nextActiveHtml :  bcSfFilterTemplate.nextDisabledHtml;
            nextHtml = nextHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage + 1));
            paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

            // Create page items array
            var beforeCurrentPageArr = [];
            for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
                beforeCurrentPageArr.unshift(iBefore);
            }
            if (currentPage - 4 > 0) {
                beforeCurrentPageArr.unshift('...');
            }
            if (currentPage - 4 >= 0) {
                beforeCurrentPageArr.unshift(1);
            }
            beforeCurrentPageArr.push(currentPage);

            var afterCurrentPageArr = [];
            for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
                afterCurrentPageArr.push(iAfter);
            }
            if (currentPage + 3 < totalPage) {
                afterCurrentPageArr.push('...');
            }
            if (currentPage + 3 <= totalPage) {
                afterCurrentPageArr.push(totalPage);
            }

            // Build page items
            var pageItemsHtml = '';
            var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
            for (var iPage = 0; iPage < pageArr.length; iPage++) {
                if (pageArr[iPage] == '...') {
                    pageItemsHtml += bcSfFilterTemplate.pageItemRemainHtml;
                } else {
                    pageItemsHtml += (pageArr[iPage] == currentPage) ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml;
                }
                pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
                pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, pageArr[iPage]));
            }
            paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);

            jQ(this.selector.pagination).html(paginationHtml);
        }
    }
};

/************************** BUILD TOOLBAR **************************/

// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function() {
    if (bcSfFilterTemplate.hasOwnProperty('sortingHtml')) {
        jQ(this.selector.topSorting).html('');

        var sortingArr = this.getSortingList();
        if (sortingArr) {
            // Build content 
            var sortingItemsHtml = '';
            for (var k in sortingArr) {
                sortingItemsHtml += '<option value="' + k +'">' + sortingArr[k] + '</option>';
            }
            var html = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
            jQ(this.selector.topSorting).html(html);

            // Set current value
            jQ(this.selector.topSorting + ' select').val(this.queryParams.sort);
        }
    }
};

/************************** END BUILD TOOLBAR **************************/

// Add additional feature for product list, used commonly in customizing product list
BCSfFilter.prototype.buildExtrasProductList = function(data, eventType) {
  if (eventType != 'init') {
    ReloadSmartWishlist();
  }
};

// Build additional elements
BCSfFilter.prototype.buildAdditionalElements = function(data, eventType) {};

// Build Default layout
function buildDefaultLink(a,b){var c=window.location.href.split("?")[0];return c+="?"+a+"="+b}BCSfFilter.prototype.buildDefaultElements=function(a){if(bcSfFilterConfig.general.hasOwnProperty("collection_count")&&jQ("#bc-sf-filter-bottom-pagination").length>0){var b=bcSfFilterConfig.general.collection_count,c=parseInt(this.queryParams.page),d=Math.ceil(b/this.queryParams.limit);if(1==d)return jQ(this.selector.pagination).html(""),!1;if("default"==this.getSettingValue("general.paginationType")){var e=bcSfFilterTemplate.paginateHtml,f="";f=c>1?bcSfFilterTemplate.hasOwnProperty("previousActiveHtml")?bcSfFilterTemplate.previousActiveHtml:bcSfFilterTemplate.previousHtml:bcSfFilterTemplate.hasOwnProperty("previousDisabledHtml")?bcSfFilterTemplate.previousDisabledHtml:"",f=f.replace(/{{itemUrl}}/g,buildDefaultLink("page",c-1)),e=e.replace(/{{previous}}/g,f);var g="";g=c<d?bcSfFilterTemplate.hasOwnProperty("nextActiveHtml")?bcSfFilterTemplate.nextActiveHtml:bcSfFilterTemplate.nextHtml:bcSfFilterTemplate.hasOwnProperty("nextDisabledHtml")?bcSfFilterTemplate.nextDisabledHtml:"",g=g.replace(/{{itemUrl}}/g,buildDefaultLink("page",c+1)),e=e.replace(/{{next}}/g,g);for(var h=[],i=c-1;i>c-3&&i>0;i--)h.unshift(i);c-4>0&&h.unshift("..."),c-4>=0&&h.unshift(1),h.push(c);for(var j=[],k=c+1;k<c+3&&k<=d;k++)j.push(k);c+3<d&&j.push("..."),c+3<=d&&j.push(d);for(var l="",m=h.concat(j),n=0;n<m.length;n++)"..."==m[n]?l+=bcSfFilterTemplate.pageItemRemainHtml:l+=m[n]==c?bcSfFilterTemplate.pageItemSelectedHtml:bcSfFilterTemplate.pageItemHtml,l=l.replace(/{{itemTitle}}/g,m[n]),l=l.replace(/{{itemUrl}}/g,buildDefaultLink("page",m[n]));e=e.replace(/{{pageItems}}/g,l),jQ(this.selector.pagination).html(e)}}if(bcSfFilterTemplate.hasOwnProperty("sortingHtml")&&jQ(this.selector.topSorting).length>0){jQ(this.selector.topSorting).html("");var o=this.getSortingList();if(o){var p="";for(var q in o)p+='<option value="'+q+'">'+o[q]+"</option>";var r=bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g,p);jQ(this.selector.topSorting).html(r);var s=void 0!==this.queryParams.sort_by?this.queryParams.sort_by:this.defaultSorting;jQ(this.selector.topSorting+" select").val(s),jQ(this.selector.topSorting+" select").change(function(a){window.location.href=buildDefaultLink("sort_by",jQ(this).val())})}}};

BCSfFilter.prototype.prepareProductData = function(data) { var countData = data.length; for (var k = 0; k < countData; k++) { data[k]['images'] = data[k]['images_info']; if (data[k]['images'].length > 0) { data[k]['featured_image'] = data[k]['images'][0] } else { data[k]['featured_image'] = { src: bcSfFilterConfig.general.no_image_url, width: '', height: '', aspect_ratio: 0 } } data[k]['url'] = '/products/' + data[k].handle; var optionsArr = []; var countOptionsWithValues = data[k]['options_with_values'].length; for (var i = 0; i < countOptionsWithValues; i++) { optionsArr.push(data[k]['options_with_values'][i]['name']) } data[k]['options'] = optionsArr; if (typeof bcSfFilterConfig.general.currencies != 'undefined' && bcSfFilterConfig.general.currencies.length > 1) { var currentCurrency = bcSfFilterConfig.general.current_currency.toLowerCase().trim(); function updateMultiCurrencyPrice(oldPrice, newPrice) { if (typeof newPrice != 'undefined') { return newPrice; } return oldPrice; } data[k].price_min = updateMultiCurrencyPrice(data[k].price_min, data[k]['price_min_' + currentCurrency]); data[k].price_max = updateMultiCurrencyPrice(data[k].price_max, data[k]['price_max_' + currentCurrency]); data[k].compare_at_price_min = updateMultiCurrencyPrice(data[k].compare_at_price_min, data[k]['compare_at_price_min_' + currentCurrency]); data[k].compare_at_price_max = updateMultiCurrencyPrice(data[k].compare_at_price_max, data[k]['compare_at_price_max_' + currentCurrency]); } data[k]['price_min'] *= 100, data[k]['price_max'] *= 100, data[k]['compare_at_price_min'] *= 100, data[k]['compare_at_price_max'] *= 100; data[k]['price'] = data[k]['price_min']; data[k]['compare_at_price'] = data[k]['compare_at_price_min']; data[k]['price_varies'] = data[k]['price_min'] != data[k]['price_max']; var firstVariant = data[k]['variants'][0]; if (getParam('variant') !== null && getParam('variant') != '') { var paramVariant = data.variants.filter(function(e) { return e.id == getParam('variant') }); if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0] } else { var countVariants = data[k]['variants'].length; for (var i = 0; i < countVariants; i++) { if (data[k]['variants'][i].available) { firstVariant = data[k]['variants'][i]; break } } } data[k]['selected_or_first_available_variant'] = firstVariant; var countVariants = data[k]['variants'].length; for (var i = 0; i < countVariants; i++) { var variantOptionArr = []; var count = 1; var variant = data[k]['variants'][i]; var variantOptions = variant['merged_options']; if (Array.isArray(variantOptions)) { var countVariantOptions = variantOptions.length; for (var j = 0; j < countVariantOptions; j++) { var temp = variantOptions[j].split(':'); data[k]['variants'][i]['option' + (parseInt(j) + 1)] = temp[1]; data[k]['variants'][i]['option_' + temp[0]] = temp[1]; variantOptionArr.push(temp[1]) } data[k]['variants'][i]['options'] = variantOptionArr } data[k]['variants'][i]['compare_at_price'] = parseFloat(data[k]['variants'][i]['compare_at_price']) * 100; data[k]['variants'][i]['price'] = parseFloat(data[k]['variants'][i]['price']) * 100 } data[k]['description'] = data[k]['content'] = data[k]['body_html']; if(data[k].hasOwnProperty('original_tags') && data[k]['original_tags'].length > 0){ data[k].tags = data[k]['original_tags'].slice(0); }} return data };

/* Start Fix version 2.3.2 */
BCSfFilter.prototype.addFilterTreeItem=function(e,r,t,i){e=jQ.parseHTML(e);if(i!=this.selector.filterTree&&i!=this.selector.filterTreeHorizontal&&jQ(i).html(""),void 0===i)i="vertical"==t?this.selector.filterTree:this.selector.filterTreeHorizontal;void 0!==r&&"before"==r?jQ(i).prepend(e):jQ(i).append(e)};
/* End Fix version 2.3.2 */

// Fix image url issue of swatch option
function getFilePath(fileName, ext, version) {
    var self = bcsffilter;
    var ext = typeof ext !== 'undefined' ? ext : 'png';
    var version = typeof version !== 'undefined' ? version : '1';
    var prIndex = self.fileUrl.lastIndexOf('?');
    if (prIndex > 0) {
        var filePath = self.fileUrl.substring(0, prIndex);
    } else {
        var filePath = self.fileUrl;
    }
    filePath += fileName + '.' + ext + '?v=' + version;
    return filePath;
}

// Build Default layout
BCSfFilter.prototype.buildDefaultElements=function(){var isiOS=/iPad|iPhone|iPod/.test(navigator.userAgent)&&!window.MSStream,isSafari=/Safari/.test(navigator.userAgent),isBackButton=window.performance&&window.performance.navigation&&2==window.performance.navigation.type;if(!(isiOS&&isSafari&&isBackButton)){var self=this,url=window.location.href.split("?")[0],searchQuery=self.isSearchPage()&&self.queryParams.hasOwnProperty("q")?"&q="+self.queryParams.q:"";window.location.replace(url+"?view=bc-original"+searchQuery)}};


BCSfFilter.prototype.getFilterData=function(eventType,errorCount){function BCSend(eventType,errorCount){var self=bcsffilter;var errorCount=typeof errorCount!=="undefined"?errorCount:0;self.showLoading();if(typeof self.buildPlaceholderProductList=="function"){self.buildPlaceholderProductList(eventType)}self.beforeGetFilterData(eventType);self.prepareRequestParams(eventType);self.queryParams["callback"]="BCSfFilterCallback";self.queryParams["event_type"]=eventType;var url=self.isSearchPage()?self.getApiUrl("search"):self.getApiUrl("filter");var script=document.createElement("script");script.type="text/javascript";var timestamp=(new Date).getTime();script.src=url+"?t="+timestamp+"&"+jQ.param(self.queryParams);script.id="bc-sf-filter-script";script.async=true;var resendAPITimer,resendAPIDuration;resendAPIDuration=2e3;script.addEventListener("error",function(e){if(typeof document.getElementById(script.id).remove=="function"){document.getElementById(script.id).remove()}else{document.getElementById(script.id).outerHTML=""}if(errorCount<3){errorCount++;if(resendAPITimer){clearTimeout(resendAPITimer)}resendAPITimer=setTimeout(self.getFilterData("resend",errorCount),resendAPIDuration)}else{self.buildDefaultElements(eventType)}});document.getElementsByTagName("head")[0].appendChild(script);script.onload=function(){if(typeof document.getElementById(script.id).remove=="function"){document.getElementById(script.id).remove()}else{document.getElementById(script.id).outerHTML=""}}}this.requestFilter(BCSend,eventType,errorCount)};BCSfFilter.prototype.requestFilter=function(sendFunc,eventType,errorCount){sendFunc(eventType,errorCount)};


/* start-boost-2.4.8 */
BCSfFilter.prototype.buildFilterOptionItem=function(html,iLabel,iValue,fOType,fOId,fOLabel,fODisplayType,fOSelectType,fOItemValue,fOData){var keepValuesStatic=fOData.hasOwnProperty("keepValuesStatic")?fOData.keepValuesStatic:false;if(fOType=="review_ratings"&&this.getSettingValue("general.ratingSelectionStyle")=="text"){var title=this.getReviewRatingsLabel(fOItemValue.from)}else{var title=this.customizeFilterOptionLabel(iLabel,fOData.prefix,fOType)}if(keepValuesStatic===true)var productNumber=null;else var productNumber=fOItemValue.hasOwnProperty("doc_count")?fOItemValue.doc_count:0;html=html.replace(/{{itemLabel}}/g,this.buildFilterOptionLabel(iLabel,productNumber,fOData));html=html.replace(/{{itemLink}}/g,this.buildFilterOptionLink(fOId,iValue,fOType,fODisplayType,fOSelectType,keepValuesStatic));html=html.replace(/{{itemValue}}/g,encodeURIParamValue(iValue));html=html.replace(/{{itemTitle}}/g,title);html=html.replace(/{{itemFunc}}/g,"onInteractWithFilterOptionValue(event, this, '"+fOType+"', '"+fODisplayType+"', '"+fOSelectType+"', '"+keepValuesStatic+"')");html=this.checkFilterOptionSelected(fOId,iValue,fOType,fODisplayType)?html.replace(/{{itemSelected}}/g,"selected"):html.replace(/{{itemSelected}}/g,"");var htmlElement=jQ(html);htmlElement.children().attr({"data-id":fOId,"data-value":encodeURIParamValue(iValue),"data-parent-label":fOLabel,"data-title":title,"data-count":productNumber});if(fOType!="collection"){htmlElement.children().attr("rel","nofollow")}if(fOType=="collection")htmlElement.children().attr("data-collection-scope",fOItemValue.key);return jQ(htmlElement)[0].outerHTML};
/* end-boost-2.4.8 */

/* Begin patch boost-010 run 2 */
BCSfFilter.prototype.initFilter=function(){return this.isBadUrl()?void(window.location.href=window.location.pathname):(this.updateApiParams(!1),void this.getFilterData("init"))},BCSfFilter.prototype.isBadUrl=function(){try{var t=decodeURIComponent(window.location.search).split("&"),e=!1;if(t.length>0)for(var i=0;i<t.length;i++){var n=t[i],a=(n.match(/</g)||[]).length,r=(n.match(/>/g)||[]).length,o=(n.match(/alert\(/g)||[]).length,h=(n.match(/execCommand/g)||[]).length;if(a>0&&r>0||a>1||r>1||o||h){e=!0;break}}return e}catch(l){return!0}};
/* End patch boost-010 run 2 */
